// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class Byte implements flatbuffers.IUnpackableObject<ByteT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Byte {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsByte(bb: flatbuffers.ByteBuffer, obj?: Byte): Byte {
    return (obj || new Byte()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsByte(bb: flatbuffers.ByteBuffer, obj?: Byte): Byte {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Byte()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  static startByte(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt8(0, value, 0);
  }

  static endByte(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createByte(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    Byte.startByte(builder);
    Byte.addValue(builder, value);
    return Byte.endByte(builder);
  }

  unpack(): ByteT {
    return new ByteT(this.value());
  }

  unpackTo(_o: ByteT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): ByteT {
    const t = new ByteT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class ByteT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return Byte.createByte(builder, this.value);
  }

  clone(): ByteT {
    const obj = new ByteT();
    obj.value = this.value;
    return obj;
  }

  equals(other: ByteT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyByte(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
  } finally {
    verifier.popDepth();
  }
}
